// import { AppTimerStateType } from '@parent-app/types';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { AppTimerStateType } from 'src/shared/types/src';

const initialState: AppTimerStateType = {} as AppTimerStateType;

const appTimerSlice = createSlice({
    name: 'appTimerSlice',
    initialState,
    reducers: {
        setAppTimer: (state, action: PayloadAction<{ lastBackgroundInitTime: number }>) => {
            state.lastBackgroundInitTime = action.payload.lastBackgroundInitTime;
        },
        setEyengageLastUpdateTime: (state, action: PayloadAction<{ eyengageLastUpdateTime: number }>) => {
            state.eyengageLastUpdateTime = action.payload.eyengageLastUpdateTime;
        }
    }
});

export const AppTimerActions = appTimerSlice.actions;
export default appTimerSlice.reducer;